import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { api, type CategoryMeta } from '../api.ts';
import { ArticleCard } from '../components/ArticleCard.tsx';
import type { ArticleSummary, Category } from '../../../shared/types.ts';

export function CategoryPage(): JSX.Element {
  const { slug } = useParams<{ slug: Category }>();
  const [articles, setArticles] = useState<ArticleSummary[] | null>(null);
  const [meta, setMeta] = useState<CategoryMeta | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!slug) return;
    setArticles(null);
    setError(null);
    api.listArticles({ category: slug })
      .then(d => {
        setArticles(d.articles);
        setMeta(d.categories[slug] ?? null);
      })
      .catch(e => setError(e instanceof Error ? e.message : 'failed to load'));
  }, [slug]);

  if (error) return <div className="center-pad">{error}</div>;
  if (!articles || !meta) return <div className="center-pad"><div className="spinner" style={{ margin: '0 auto' }} /></div>;

  return (
    <div className="page">
      <div style={{ marginBottom: 12, fontSize: 13, color: 'var(--text-faint)' }}>
        <Link to="/">Home</Link> / {meta.label}
      </div>
      <h1 style={{ fontSize: 'clamp(28px, 4vw, 38px)', margin: '0 0 8px', letterSpacing: '-.02em' }}>{meta.label}</h1>
      <p style={{ color: 'var(--text-dim)', maxWidth: 700, fontSize: 17, marginBottom: 28 }}>{meta.blurb}</p>
      {articles.length === 0 ? (
        <div className="center-pad">
          No articles published in this category yet — but they're <Link to="/roadmap">on the roadmap</Link>.
        </div>
      ) : (
        <div className="article-grid">
          {articles.map(a => <ArticleCard key={a.slug} a={a} />)}
        </div>
      )}
    </div>
  );
}
